export default __webpack_public_path__ + "static/media/Flag_of_Montenegro.0afef6a7.svg";